export default {
  yesNo(value) {
    return value ? 'Sim' : 'Não'
  }
}
